import React, { useEffect, useState } from 'react'
import { Modal, Button, Spin, Select, Alert } from 'antd'
import { listPartner, updateNewPartnerV2 } from '../../../../../services/api/3dApi'
import queryString from 'query-string'
import Promise from 'bluebird'
import classNames from 'classnames'

const { Option } = Select

const isFbaBatch = (batch) => {
    const { tags } = Object.assign({}, batch)
    return Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
}

const statusColor = (status) => classNames({
    'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
    'printing progress-bar-animated progress-bar-striped': status === 'printing',
    'printed': status === 'printed',
    'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
    'transferred': status === 'transferred',
    'confirmed': status === 'confirmed',
    'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
    'sewing': status === 'sewing',
    'completed': status === 'completed' || status === 'done',
    'embroidered': status === 'embroidered',
    'designed': status === 'designed',
})

const ActionChangePrintPartner = ({ isOpen, closeModal, selectedItems, refreshBatches, toggleSelectAll, batches }) => {
    const [partnerId, setPartnerId] = useState('')
    const [listPartners, setListPartners] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [isChange, setIsChange] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemError, setItemError] = useState([])

    // Chỉ lấy các lô FBA trong danh sách đã chọn để hiển thị lên modal
    const fbaBatches = batches.filter(batch => selectedItems.includes(batch._id) && isFbaBatch(batch))

    const _fetchPartners = async () => {
        try {
            const query = queryString.stringify({ type: 'print_partner' })
            const { data: response } = await listPartner(query)
            const { data, success, error } = response

            if (!success) {
                return setError(error)
            }

            const { partners } = data
            setListPartners(partners)
            setError('')
        } catch (e) {
            setError(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            // Reset state mỗi lần mở để luôn bắt đầu từ form sạch,
            // bất kể lần trước đóng bằng cách nào (Đóng / Hủy / X / X giữa lúc đang chạy)
            _resetState()
            _fetchPartners()
        }
    }, [isOpen])

    const onChangePartner = (value) => {
        setPartnerId(value)
    }

    const onConfirm = async () => {
        setLoading(true)
        setIsChange(true)

        await Promise.each(fbaBatches, async (batch) => {
            if (batch.status !== 'pending') {
                itemError.push({
                    _id: batch._id,
                    message: `Lô đang ở trạng thái '${batch.status}', chỉ đổi được đối tác khi lô ở trạng thái 'pending'`
                })
                setItemError([...itemError])
                return
            }

            try {
                const { data: response } = await updateNewPartnerV2(batch._id, { partnerId: partnerId })
                const { success, error } = response

                if (!success) {
                    itemError.push({ _id: batch._id, message: error })
                    setItemError([...itemError])
                } else {
                    itemsSuccess.push(batch._id)
                    setItemsSuccess([...itemsSuccess])
                }
            } catch (e) {
                itemError.push({ _id: batch._id, message: e.message })
                setItemError([...itemError])
            }
        })

        setLoading(false)
    }

    const _showMessage = (_id) => {
        const errored = itemError.find(itemErr => _id === itemErr._id)
        if (errored !== undefined) {
            return errored.message
                ? <span className="d-sm-block text-danger">{errored.message}</span>
                : <span className="d-sm-block">Loading...</span>
        } else if (itemsSuccess.includes(_id)) {
            return <span className="d-sm-block text-success">Đổi đối tác in/ép thành công!</span>
        }
        return <span className="d-sm-block">Waiting...</span>
    }

    const _resetState = () => {
        setPartnerId('')
        setIsChange(false)
        setItemsSuccess([])
        setItemError([])
    }

    // Đóng sau khi đã đổi đối tác: reset state + bỏ chọn + refresh danh sách
    const _handleClose = () => {
        _resetState()
        closeModal()
        toggleSelectAll(false)
        refreshBatches()
    }

    // Hủy / đóng bằng nút X khi chưa xử lý: chỉ reset state nội bộ + đóng modal,
    // không bỏ chọn / không refresh để giữ nguyên hành vi cũ (không có thao tác nào chạy)
    const _handleCancel = () => {
        if (loading) return closeModal()
        _resetState()
        closeModal()
    }

    return (
        <Modal
            title="Đổi đối tác in/ép"
            visible={isOpen}
            className={'CustomModal'}
            width={950}
            onOk={onConfirm}
            onCancel={_handleCancel}
            footer={[
                <Button key="back" onClick={_handleCancel} className={!isChange ? '' : 'd-none'}>
                    Hủy
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    disabled={!partnerId || !fbaBatches.length}
                    onClick={onConfirm}
                    className={!isChange ? '' : 'd-none'}
                >
                    Đổi đối tác
                </Button>,
                <Button key="close" onClick={_handleClose} className={`bg-grey ml-2 ${isChange ? '' : 'd-none'}`}>
                    Đóng
                </Button>
            ]}
        >
            {!fbaBatches.length ? (
                <Alert message="Không có lô FBA nào trong danh sách đã chọn." type="warning" />
            ) : !isChange ? (
                <>
                    <div className="mb-3">
                        <label className="d-block">Chọn đối tác in/ép mới</label>
                        <Select
                            value={partnerId}
                            style={{ minWidth: 300 }}
                            onChange={onChangePartner}
                            dropdownClassName="custom-select-partner"
                            placeholder="Chọn đối tác"
                        >
                            {listPartners.length > 0 && listPartners.map((item) =>
                                <Option key={item._id} value={item._id}>{item.name}</Option>
                            )}
                        </Select>
                        {error && <Alert message={error} type="error" className="mt-3" />}
                    </div>
                    <div className="mt-2">
                        <p className="mb-2">Danh sách <b>{fbaBatches.length}</b> lô FBA cần đổi đối tác in/ép:</p>
                        <ul className="Status pl-3" style={{ columnCount: 3, columnGap: '24px' }}>
                            {fbaBatches.map(item => (
                                <li key={item._id} className="mb-1" style={{ breakInside: 'avoid' }}>
                                    <strong>{item.name}</strong>
                                    <span className={`badge ${statusColor(item.status)} badge-pill mx-1`}>{item.status}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {!!partnerId &&
                        <p>Bạn có chắc chắn muốn đổi đối tác in/ép cho <b>{fbaBatches.length}</b> lô FBA được chọn không?</p>
                    }
                </>
            ) : (
                <div className="ListChangeStatusBatch">
                    {fbaBatches.map(item => (
                        <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                            <div className="IconStatus mr-2 d-flex align-items-end">
                                {itemsSuccess.includes(item._id) && (
                                    <Button icon="check" className="icon-check text-success"></Button>
                                )}
                                {(itemError.find(itemErr => item._id === itemErr._id) !== undefined
                                    && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                    <Button icon="cross" className="icon-cross text-danger"></Button>
                                )}
                            </div>
                            <div className="ContentGenLabel">
                                <strong className="mr-2">{item.name}</strong>
                                {loading && <Spin />}
                                {_showMessage(item._id)}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    )
}

export default ActionChangePrintPartner
